export function getUrlVars(url) {
	if(!url) url = location.href;
	var question = url.indexOf("?");
	var hashIdx = url.indexOf("#");
	if(hashIdx==-1 && question==-1) return {};
	if(hashIdx==-1) hashIdx = url.length;
	var query = question==-1 || hashIdx==question+1 ? url.substring(hashIdx) : 
		url.substring(question+1,hashIdx);
	var result = {};
	query.split("&").forEach(function(part) {
		if(!part) return;
		part = part.split("+").join(" "); // replace every + with space, regexp-free version
		var eq = part.indexOf("=");
		var key = eq>-1 ? part.substr(0,eq) : part;
		var val = eq>-1 ? decodeURIComponent(part.substr(eq+1)) : "";
		var from = key.indexOf("[");
		if(from==-1) result[decodeURIComponent(key)] = val;
		else {
			var to = key.indexOf("]",from);
			var index = decodeURIComponent(key.substring(from+1,to));
			key = decodeURIComponent(key.substring(0,from));
			if(!result[key]) result[key] = [];
			if(!index) result[key].push(val);
			else result[key][index] = val;
		}
	});
	return result;
}
